exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".icon-side-menu[data-v-58b8a85a]{margin-right:15px}", "", {"version":3,"sources":["/usr/msl_nlp/front-bot/src/components/Shared/Menu/components/side.menu.dashboard.component.vue"],"names":[],"mappings":"AACA,iCAAiC,iBAAiB,CACjD","file":"side.menu.dashboard.component.vue","sourcesContent":["\n.icon-side-menu[data-v-58b8a85a]{margin-right:15px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58b8a85a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Shared/Menu/components/side.menu.dashboard.component.vue
// module id = 861
// module chunks = 66